import { Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { useMemo } from 'react'

import { PureAsyncSearchInput } from 'src/components/Formik/Forms/PureAsyncSearchInput'

import { formatLabelPerson } from 'src/modules/pessoas/utils'
import { formatLabelEndereco } from 'src/modules/pessoas/utils/labelFormatEndereco'

import { LotesFormData } from '../../types'

interface Props {
  isRestrictedEdit: boolean
}

export const DestinatarioFields = ({ isRestrictedEdit }: Props) => {
  const { values } = useFormikContext<LotesFormData>()

  const enderecoDestinatarioFilters = useMemo(
    () => ({
      pessoaId: values.destinatario?.value
    }),
    [values.destinatario?.value]
  )

  return (
    <>
      <Grid item xs={12} sm={3}>
        <PureAsyncSearchInput
          name="destinatario"
          label="Destinatário (opcional)"
          url="/pessoas"
          filters={{ ativo: true }}
          labelFormat={formatLabelPerson}
          paramSearch="nomeDocumento"
          disabled={isRestrictedEdit}
          allowSearchWhenDisabled
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <PureAsyncSearchInput
          name="enderecoDestinatario"
          label="Endereço Destinatário (opcional)"
          url="/enderecos"
          filters={enderecoDestinatarioFilters}
          labelFormat={formatLabelEndereco}
          paramSearch="logradouro"
          disabled={!values.destinatario?.value || isRestrictedEdit}
          allowSearchWhenDisabled
        />
      </Grid>
    </>
  )
}
